// source: types/v1/calendar_event_type.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.types.v1.CalendarEventType', null, global);
/**
 * @enum {number}
 */
proto.types.v1.CalendarEventType = {
  CALENDAR_EVENT_TYPE_UNSPECIFIED: 0,
  CALENDAR_EVENT_TYPE_EXAM: 1
};

goog.object.extend(exports, proto.types.v1);
